import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('TemplateContents')
export default class TemplateContents {
  constructor() {
    this.order = undefined;
    this.smallCategory = undefined;
    this.smallCategoryCss = undefined;
    this.templateContents = undefined;
    this.templateContentsCss = undefined;
    this.notes = undefined;
    this.notesCss = undefined;
  }

  @JsonProperty('order')
  public order?: number;

  @JsonProperty('small_category')
  public smallCategory?: string;

  @JsonProperty('small_category_css')
  public smallCategoryCss?: string;

  @JsonProperty('template_contents')
  public templateContents?: string;

  @JsonProperty('template_contents_css')
  public templateContentsCss?: string;

  @JsonProperty('notes')
  public notes?: string;

  @JsonProperty('notes_css')
  public notesCss?: string;
}
